module.exports = __webpack_public_path__ + "img/Stamp.23ae66f1.svg";